// extracted by mini-css-extract-plugin
export default {"form":"queue-page_form__AqNck","wrapper":"queue-page_wrapper__iN3R7","series":"queue-page_series__M+X-P"};